import { render, staticRenderFns } from "./UnderRevieForm.vue?vue&type=template&id=2d83adaa&scoped=true&"
import script from "./UnderRevieForm.vue?vue&type=script&lang=js&"
export * from "./UnderRevieForm.vue?vue&type=script&lang=js&"
import style0 from "./UnderRevieForm.vue?vue&type=style&index=0&id=2d83adaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83adaa",
  null
  
)

export default component.exports